import { GetServerSideProps, NextPage } from "next";
import useQuery from "../../../hooks/useQuery";
import React, { Suspense, useEffect, useState } from "react";
import dynamic from "next/dynamic";
import Head from "next/head";
import CommunityController from "../../../controller/community.controller";
import { ListingPageProps } from "../../../types/ListingPage.interface";
import VerifyModal from "../../../components/VerifyModal";
import useStore from "../../../context/useStore";

const DesktopView = dynamic(
  () => import("../../../Layout/CityPage/DesktopCityPage"),
  {
    suspense: true,
  }
);
const MobileView = dynamic(
  () => import("../../../Layout/CityPage/MobileCityPage"),
  {
    suspense: true,
  }
);
const Filters = dynamic(() => import("../../../components/Listing/Filters"), {
  suspense: true,
});
const Community: NextPage<ListingPageProps> = ({
  query,
  city,
  community,
  properties,
  mapLine,
  mapListing,
  isMobile,
}) => {
  const queries = useQuery(query);
  const [visible, setVisible] = useState(false);

  const { verify, setVerify } = useStore();
  const onClose = () => {
    setVerify({
      open: false,
      closable: true,
    });
  };
  useEffect(() => {
    setVisible(verify.open);
  }, [verify.open]);
  return (
    <>
      <Head>
        <title>{community?.title}</title>
        <meta
          name="title"
          property="og:title"
          content={(community?.title && community.title) || ""}
        />

        <meta
          name="description"
          property="og:description"
          content={(community?.desc && community.desc) || ""}
        />

        <meta
          name="keywords"
          content={community?.keywords ? `${community.keywords}` : ``}
        />

        <meta property="og:type" content="website" />
        <meta
          property="og:url"
          content={`https://bungalowfinder.ca/city/${city.slug}/${community?.slug}`}
        />

        <meta
          property="og:image"
          itemProp="image"
          content={`https://api.bungalowfinder.ca` + city.image?.images.og.url}
        />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta
          property="og:image:alt"
          content={(community?.title && community.title) || ""}
        />
        <meta name="twitter:card" content="summary" />
        <meta
          name="twitter:title"
          content={(community?.title && community.title) || ""}
        />
        <meta
          name="twitter:description"
          content={(community?.desc && community.desc) || ""}
        />
        <meta
          name="twitter:image"
          content={
            `https://api.bungalowfinder.ca` + community?.image?.images.og.url
          }
        />
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: `${(community?.jsonLD && community.jsonLD) || ""}`,
          }}
        ></script>
      </Head>
      <div className="flex-1 flex flex-col">
        <div className="bg-primary z-10">
          <div className="bg-primary mix-blend-screen text-white py-3">
            <div className="container mx-auto flex justify-end">
              <Suspense
                fallback={
                  <>
                    <p>Loading...</p>
                  </>
                }
              >
                <Filters query={query} queries={queries} isMobile={isMobile} />
              </Suspense>
            </div>
          </div>
        </div>
        {isMobile ? (
          <Suspense>
            <MobileView
              query={query}
              community={community}
              city={city}
              properties={properties}
            />
          </Suspense>
        ) : (
          <Suspense>
            <DesktopView
              query={query}
              city={city}
              community={community}
              properties={properties}
              mapLine={mapLine}
              mapListing={mapListing}
            />
          </Suspense>
        )}
      </div>
      <VerifyModal open={visible} onClose={onClose} />
    </>
  );
};

export default Community;

export const getServerSideProps: GetServerSideProps = async (context) => {
  return await CommunityController(context);
};
